import { call, debounce, fork, put, select, takeLatest } from 'redux-saga/effects';
import postData from '@utils/postData';
import fetchData from '@utils/fetchData';
import { handleSagaError, handleSagaSuccess } from '@utils/sagaHelper';
import { catchException, processSagaError } from '@utils/catchException';
import { fetchLegacyLiveSessionRequest, processStepDetailsRequest, storeMeetingExternalId, updateMeetingParticipationStatusRequest, } from './slice';
import { GET_LEGACY_LIVE_SESSION, UPDATE_MEETING_PARTICIPATION_STATUS } from './queries';
import { fetchStepDetailsSagaWorker } from '@containers/App/saga';
import { selectAppStepDetails } from '@containers/App/selectors';
import { JOIN_INTERVIEW_PRE_REGISTRATION_FORM, localStorageGetItem } from '@utils/localStorageHelpers';
import { selectPreInterviewFormId } from './selectors';
export function* updateMeetingParticipationStatusSagaWorker({ payload, }) {
    try {
        const { status, meeting_participant_id } = payload.data;
        const queryResponse = (yield call(postData, {
            queryString: UPDATE_MEETING_PARTICIPATION_STATUS,
            payload: { status, meeting_participant_id },
        }));
        const participationStatusResponse = queryResponse?.data?.sch_update_meeting_participant_status[0];
        if (participationStatusResponse?.success) {
            yield call(handleSagaSuccess, {
                callback: payload.callback?.onSuccess,
                response: participationStatusResponse,
            });
        }
        else {
            throw catchException.validationError(`An error occurred while updating the meetingParticipation Status ${participationStatusResponse?.error_message}`, { meeting_participant_id, status, participationStatusResponse });
        }
    }
    catch (error) {
        yield call(handleSagaError, {
            callback: payload.callback?.onError,
            error: processSagaError(error, 'An error occurred in updateMeetingParticipationStatusSagaWorker'),
            title: 'Meeting Participant Update',
            skipToast: true,
        });
    }
}
export function* processStepDetailsWorker(action) {
    try {
        const { callback } = action.payload;
        // Fetch step details using the App saga worker
        yield call(fetchStepDetailsSagaWorker, action);
        // Get the step details from Redux store using selector
        const stepDetailsResponse = yield select(selectAppStepDetails);
        if (stepDetailsResponse) {
            // use stepDetailsResponse here to check response
            // JoinInterview specific logic - Form checks using selector
            const formId = yield select(selectPreInterviewFormId);
            const hasJoinForm = localStorageGetItem(JOIN_INTERVIEW_PRE_REGISTRATION_FORM);
            // If form exists and not submitted, trigger callback with form handling info
            if (formId && hasJoinForm !== 'true') {
                if (callback?.onSuccess) {
                    yield call(callback.onSuccess, {
                        ...stepDetailsResponse,
                        formId,
                    });
                }
                return;
            }
            // If no form needed or form already submitted, proceed normally
            if (callback?.onSuccess) {
                yield call(callback.onSuccess, stepDetailsResponse);
            }
        }
    }
    catch (error) {
        yield call(handleSagaError, {
            callback: action.payload.callback?.onError,
            error: processSagaError(error, 'An error occurred in processStepDetailsWorker'),
            title: 'JoinInterview Step Details Processing',
            skipToast: true,
        });
    }
}
export function* fetchLegacyLiveSessionWorker({ payload }) {
    try {
        const { id } = payload;
        const queryResponse = (yield call(fetchData, {
            queryString: GET_LEGACY_LIVE_SESSION,
            queryVariables: { id },
            queryKey: 'frm_legacy_live_session',
            forceRefresh: true,
            context: {},
        }));
        // Extract external ID from the response and update Redux state
        if (queryResponse && queryResponse.length > 0) {
            const externalId = queryResponse[0]?.assessment_section_candidate?.assessment_section?.section?.external_id;
            yield put(storeMeetingExternalId(externalId || null));
        }
        else {
            yield put(storeMeetingExternalId(null));
        }
    }
    catch (_error) {
        yield put(storeMeetingExternalId(null));
    }
}
export function* updateMeetingParticipationStatusSagaWatcher() {
    yield takeLatest(updateMeetingParticipationStatusRequest.type, updateMeetingParticipationStatusSagaWorker);
}
export function* processStepDetailsWatcher() {
    yield takeLatest(processStepDetailsRequest.type, processStepDetailsWorker);
}
export function* fetchLegacyLiveSessionWatcher() {
    yield debounce(500, fetchLegacyLiveSessionRequest.type, fetchLegacyLiveSessionWorker);
}
export function* joinInterviewRootSaga() {
    yield fork(updateMeetingParticipationStatusSagaWatcher);
    yield fork(processStepDetailsWatcher);
    yield fork(fetchLegacyLiveSessionWatcher);
}
